<template>
  <div class="list-wrapper">
    <div class="content-wrapper">
      <div class="h-full">
        <div class="c_group">
          <query-form
            class="content_block"
            label-width="90px"
            size="small"
            label-position="right"
            @search="getList('init')"
            @reset="handleReset"
            :keepOpenedRow="2">
            <el-form-item label="订单状态" :span="24">
              <check-tag v-model="advancedForm.status" @change="() => getList('init')">
                <check-tag-item
                  :value="i.en"
                  :key="i.en"
                  v-for="i in executionStatusGroup"
                  :label="`${i.label}${!['deliveryCount', 'rejectCount', 'cancelCount'].includes(i.en) ? '(' + (i.count || 0) + ')' : ''}`"
                ></check-tag-item>
              </check-tag>
            </el-form-item>
            <el-form-item label="收货状态" :span="24">
              <check-tag v-model="advancedForm.receiveStatus" @change="() => getList('init')">
                <check-tag-item
                  :value="i.value"
                  :key="'receive-'+i.value"
                  v-for="i in receiveStatusOptions"
                  :label="`${i.label}${i.value === '1' ? '(' + (i.count || 0) + ')' : ''}`"
                ></check-tag-item>
              </check-tag>
            </el-form-item>
            <el-form-item label="订单编号">
              <el-input
                v-model.trim="advancedForm.code"
                clearable
                placeholder="请输入订单编号"
              ></el-input>
            </el-form-item>
            <el-form-item label="客户抬头">
              <el-input
                v-model.trim="advancedForm.customerName"
                clearable
                placeholder="请输入客户抬头"
              ></el-input>
            </el-form-item>
            <el-form-item label="订单来源">
              <el-select
                v-model.trim="advancedForm.sourceType"
                clearable
                placeholder="请选择"
                @change="getList('init')"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="平台销售" value="1"></el-option>
                <el-option label="订阅销售" value="2"></el-option>
                <el-option label="客户推送" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开票状态">
              <el-select
                v-model.trim="advancedForm.invoiceStatus"
                clearable
                placeholder="请选择"
                @change="getList('init')"
              >
                <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="(item, index) in invoiceStatusOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="收款状态">
              <el-select
                v-model.trim="advancedForm.collectionStatus"
                clearable
                placeholder="请选择"
                @change="getList('init')"
              >
              <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="item in collectionStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="物流填单">
              <el-select v-model.trim="advancedForm.logisticsFillType" clearable placeholder="请选择" @change="getList('init')">
                <el-option label="全部" value=""></el-option>
                <el-option label="未确认" :value="1"></el-option>
                <el-option label="线下填单" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="收货人">
              <el-input
                v-model.trim="advancedForm.receiverName"
                clearable
                placeholder="请输入收货人"
              ></el-input>
            </el-form-item>
            <el-form-item label="收货人手机">
              <el-input
                v-model.trim="advancedForm.receiverPhone"
                clearable
                placeholder="请输入收货人手机"
              ></el-input>
            </el-form-item>
            <el-form-item label="销售合同">
              <el-input
                v-model.trim="advancedForm.contractCode"
                clearable
                placeholder="请输入销售合同"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                v-model.trim="advancedForm.remark"
                clearable
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
            <el-form-item label="对方单据号">
              <el-input
                v-model.trim="advancedForm.outOrderCode"
                clearable
                placeholder="请输入对方单据号"
              ></el-input>
            </el-form-item>
          </query-form>
        </div>
        <div class="table-wrapper" :class="{ 'fullscreen': isFullScreen }">
          <xz-table
            ref="xzTable"
            :columns="columnList"
            :data="dataList"
            :toolsAttrs="toolsAttrs"
            :scroll="{ x: '100%', y: scrollHeight }"
            rowKey="id"
            :enableRowSelection="true"
            :selectedRowKeys="selectedKeys"
            :getCheckboxProps="(record) => ({
              props: {
                disabled: !(record.status === 3 && [1, 2].includes(record.deliveryStatus)),
              },
            })"
            :isNest="true"
            :expandedRowKeys.sync="expandedRowKeys"
            @openCloseAll="openCloseAll"
            @change="handleSelectionChange"
            @refresh="handleReset"
            @fullScreen="handleFullScreen"
            @expand="expandedOneRow">
            <template #buttons>
              <el-button v-if="showUpdateDelivery && $withPermission('gongxutong:sale:order:sync')" type="primary" size="mini" @click="handleUpdate">订单更新</el-button>
              <el-button :disabled="!selectedKeys.length" @click="handleBatchFillOrder" type="primary" size="mini">批量线下填单</el-button>
            </template>
            <template #custom>
              <tableHeaderConfiguration businessType="pickUpOrders" :disabledList="disabledList" :baseLists="baseLists" @updateColumnList="updateColumnList" />
            </template>
            <div slot="action" slot-scope="_, row">
              <a v-if="$withPermission('gongxutong:sale:order:detail')" @click="() => operate('detail', row)">查看</a>
              <a v-if="row.status === 3 && [1, 2].includes(row.deliveryStatus) && $withPermission('gongxutong:sale:order:delivery')" style="margin-left: 8px" @click="() => operate('delivery', row)">发货</a>
              <a v-if="row.status === 6 && confirmPermission" style="margin-left: 8px" @click="() => confirmOrder(row)">确认</a>
            </div>
            <xz-table
              rowKey="id"
              class="subTable subTableSelect"
              slot="expandedRowRender"
              slot-scope="row"
              :columns="subColumnsLists"
              :data="row.orderGoodsList">
              <template slot="imageList" slot-scope="image">
                <span v-if="image && image.split(',').length > 0">
                  <span v-for="(img, i) in image.split(',')" :key="'img-'+i">
                    <el-image v-if="i < 2" style="width: 32px; height: 32px; margin-right: 5px;" :src="img" :preview-src-list="image.split(',')" />
                  </span>
                  <span v-if="image.split(',').length > 2" style="color:#3182bd; margin-left: 2px;">...</span>
                </span>
                <span v-else>暂无图片</span>
              </template>
            </xz-table>
          </xz-table>
        </div>
      </div>
    </div>
    <div class="pagination-wrapper">
      <a-pagination
        :current="pagination.pageNum"
        :total="total"
        :show-total="total => `共 ${total || 0} 条`"
        show-size-changer
        :pageSizeOptions="['10', '20', '30', '50', '100']"
        show-quick-jumper
        :pageSize.sync="pagination.pageSize"
        @change="handleNumChange"
        @showSizeChange="handleSizeChange"
      />
    </div>
  </div>
</template>
<script>
import * as Moment from 'dayjs';
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import tableHeaderConfiguration from '@/components/tableHeaderConfiguration.vue';
import { queryPage, querySaleOrderCount, pullXzErpOrder, confirm } from '@/api/pickUpOrders';
import { getTenantSellerSettingDetail, tenantDetail } from '@/api/shop';
import { findAuthorization } from '@/utils/findAuthorization';
import setTableCols from './configs';
import {
  receiveStatusOptions,
  collectionStatusOptions,
  invoiceStatusOptions,
} from '@/model/pickUpOrders';

const executionStatusGroup = [
  {
    label: '全部',
    value: '',
    en: 'allCount',
    count: 0,
  },
  {
    label: '待确认',
    value: '6',
    en: 'waitConfirmCount',
    count: 0,
  },
  {
    label: '待发货',
    value: '1',
    en: 'waitDeliveryCount',
    count: 0,
  },
  {
    label: '部分发货',
    value: '2',
    en: 'partDeliveryCount',
    count: 0,
  },
  {
    label: '已发货',
    value: '3',
    en: 'deliveryCount',
    count: 0,
  },
  {
    label: '已驳回',
    value: '2',
    en: 'rejectCount',
    count: 0,
  },
  {
    label: '已取消',
    value: '4',
    en: 'cancelCount',
    count: 0,
  },
];

export default {
  name: 'PickUpOrders',
  components: {
    xzTable,
    tableHeaderConfiguration,
  },
  data () {
    return {
      expandedRowKeys: [],
      showUpdateDelivery: false,
      Moment,
      disabledList: [],
      dataList: [],
      advancedForm: {
        deliveryStatus: '',
        contractCode: '',
        sourceType: '',
        invoiceStatus: '',
        collectionStatus: '',
        logisticsFillType: '',
        receiverName: '',
        receiverPhone: '',
        code: '',
        outOrderCode: '',
        customerName: '',
        receiveStatus: '',
        status: 'allCount',
        remark: '',
        orderByProperty: '',
        orderByType: '',
      },
      executionStatusGroup,
      receiveStatusOptions,
      collectionStatusOptions,
      invoiceStatusOptions,
      scrollHeight: 'calc(100vh - 220px - 70px - 155px)',
      columnList: [
        ...setTableCols.call(this),
      ],
      baseLists: [
        ...setTableCols.call(this),
      ],
      subColumnsLists: [
        ...setTableCols.call(this, 'detail'),
      ],
      isFullScreen: false,
      total: 0,
      pagination: {
        pageNum: 1,
        pageSize: 10,
      },
      confirmPermission: false,
      selectedKeys: [],
      selectedLists: [],
    };
  },
  watch: {
    $route: function () {
      if (localStorage.getItem('refresh')) {
        this.selectedKeys = [];
        this.selectedLists = [];
        localStorage.removeItem('refresh');
        this.getList();
        this.getSaleContractCount();
      }
    },
  },
  async created () {
    const userInfo = this.$local.get('userInfo') ? JSON.parse(this.$local.get('userInfo')) : {};
    const { body } = await tenantDetail({
      id: userInfo.tenantId,
      findActivateServiceFlag: true,
    });
    if (body.activateService && body.activateService.includes('小紫VIS')) {
      this.showUpdateDelivery = true;
    }
    if (this.$route.query?.status === 'waitDeliveryCount') {
      this.advancedForm.status = 'waitDeliveryCount';
    }
    await this.queryTenantSellerSettingDetail();
    this.getList();
    this.getSaleContractCount();
  },
  computed: {
    toolsAttrs () {
      return {
        refresh: true,
        zoom: true,
        fullScreen: this.isFullScreen,
        // advancedSearch: true,
        custom: true,
      };
    },
  },
  methods: {
    updateColumnList (columnList) {
      this.columnList = [
        ...columnList,
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          fixed: 'right',
          width: 100,
          scopedSlots: { customRender: 'action' },
        },
      ];
      setTimeout(() => {
        this.expandedRowKeys = [];
        this.$refs.xzTable.addElementsToClass();
      }, 0);
    },
    handleFullScreen () {
      this.isFullScreen = !this.isFullScreen;
    },
    handleSelectionChange (keys, rows) {
      // 移除
      if (this.selectedKeys.length > keys.length) {
        const diff = this.selectedKeys.filter(item => !keys.includes(item));
        this.selectedLists = this.selectedLists.filter(item => !diff.includes(item.id));
      }
      // 增加
      if (this.selectedKeys.length < keys.length) {
        const diff = keys.filter(item => !this.selectedKeys.includes(item));
        const list = rows.filter(item => diff.includes(item.id));
        this.selectedLists = [...this.selectedLists, ...list];
      }
      this.selectedKeys = keys;
    },
    handleSizeChange (_, size) {
      this.pagination.pageSize = size;
      this.getList();
    },
    handleNumChange (num) {
      this.pagination.pageNum = num;
      this.getList();
    },
    openCloseAll () {
      setTimeout(() => {
        this.expandedRowKeys.forEach((key) => {
          const elements = document.querySelectorAll(`[data-row-key='${key}-extra-row']`);
          const length = elements.length;
          const height = elements[0].offsetHeight - 18.6;
          const tableContents = elements[0].querySelectorAll('.ant-table-content');
          if (tableContents.length) {
            for (let i = 0; i < tableContents.length; i++) {
              tableContents[i].style.paddingRight = 200 + 'px';
            }
          }

          elements[length - 1].childNodes[0].innerHTML = `<div style='height: ${height}px;'></div>`;

          // 设置fixed-left时，子表格paddingRight为0
          const fixedTableLeft = document.querySelectorAll('.ant-table-fixed-left');
          if (fixedTableLeft.length) {
            const fixedRows = fixedTableLeft[0].querySelectorAll(`[data-row-key='${key}-extra-row']`);
            if (fixedRows.length) {
              const fixedRowsSecondTd = fixedRows[0].querySelectorAll('td')[1];
              if (fixedRowsSecondTd) {
                fixedRowsSecondTd.style.paddingRight = 0;
              }
            }
          }
        });
      }, 0);
    },
    expandedOneRow (_, rec) {
      setTimeout(() => {
        const elements = document.querySelectorAll(`[data-row-key='${rec.id}-extra-row']`);
        const length = elements.length;
        const height = elements[0].offsetHeight - 18.6;
        const tableContents = elements[0].querySelectorAll('.ant-table-content');

        if (tableContents.length) {
          for (let i = 0; i < tableContents.length; i++) {
            tableContents[i].style.paddingRight = 200 + 'px';
          }
        }

        elements[length - 1].childNodes[0].innerHTML = `<div style='height: ${height}px;'></div>`;

        // 设置fixed-left时，子表格paddingRight为0
        const fixedTableLeft = document.querySelectorAll('.ant-table-fixed-left');
        if (fixedTableLeft.length) {
          const fixedRows = fixedTableLeft[0].querySelectorAll(`[data-row-key='${rec.id}-extra-row']`);
          if (fixedRows.length) {
            const fixedRowsSecondTd = fixedRows[0].querySelectorAll('td')[1];
            if (fixedRowsSecondTd) {
              fixedRowsSecondTd.style.paddingRight = 0;
            }
          }
        }
      }, 0);
    },
    async handleUpdate () {
      const { body } = await pullXzErpOrder({});
      this.$message.success(`更新成功，共更新 ${body} 条数据`);
      this.handleReset();
    },
    handleReset () {
      for (let key in this.advancedForm) {
        this.advancedForm[key] = '';
      }
      this.total = 0;
      this.pagination = {
        pageNum: 1,
        pageSize: 10,
      };

      this.getList();
    },
    getList (type) {
      if (type === 'init') {
        this.selectedKeys = [];
        this.selectedLists = [];
        this.pagination = {
          pageNum: 1,
          pageSize: 10,
        };
      }

      let { pageSize, pageNum } = this.pagination;
      let orderBy = [
        {
          orderByProperty: this.advancedForm.orderByProperty || 'lastUpdateTime',
          orderByType: this.advancedForm.orderByType || 'DESC',
        },
      ];

      // 处理订单状态选中
      const statusOption = {
        status: '',
        deliveryStatus: '',
      };

      if (this.advancedForm.status === 'allCount') {
        statusOption.status = '';
        statusOption.deliveryStatus = '';
      } else if (this.advancedForm.status) {
        const deliveryStatusEn = ['waitDeliveryCount', 'partDeliveryCount', 'deliveryCount'];
        const orderStatusEn = ['waitConfirmCount', 'rejectCount', 'cancelCount'];
        if (orderStatusEn.includes(this.advancedForm.status)) {
          const statusObj = this.executionStatusGroup.find(item => item.en === this.advancedForm.status);
          statusOption.status = statusObj?.value || '';
          statusOption.deliveryStatus = '';
        } else if (deliveryStatusEn.includes(this.advancedForm.status)) {
          const statusObj = this.executionStatusGroup.find(item => item.en === this.advancedForm.status);
          statusOption.deliveryStatus = statusObj?.value || '';
          statusOption.status = '';
          if (statusOption.deliveryStatus === '1') {
            statusOption.status = '3';
          }
        }
      }

      queryPage({ ...this.advancedForm, ...statusOption, findOrderGoodsFlag: true, orderBy, pageSize, pageNum, findOrderGoodsSerialFlag: true, findOrderGoodsDeliveredQuantityFlag: true }).then(
        ({body}) => {
          const data = (body.list || []).map(v => {
            v.orderGoodsList.map(item => {
              item.dockingSystem = v.dockingSystem;
            });
            return v;
          });
          this.dataList = data;
          this.total = +body.total || 0;
          setTimeout(() => {
            this.expandedRowKeys = [];
            this.$refs.xzTable.addElementsToClass();
          }, 0);
        },
      );
    },
    getSaleContractCount () {
      querySaleOrderCount().then(({ body }) => {
        for (let v of this.executionStatusGroup) {
          v.count = body[v.en];
        }
        for (let v of this.receiveStatusOptions) {
          v.count = body[v.en];
        }
      });
    },
    // 确认订单
    async confirmOrder (row) {
      this.$confirm('确认订单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        await confirm({
          id: row.id,
          tenantId: userInfo.tenantId,
        });
        this.$message.success('订单已确认');
        this.getList();
      });
    },
    handleBatchFillOrder () {
      // 过滤出 orderGoodsList 中 unDeliveredQuantity 大于0的商品
      const filteredSelectedAllLists = this.selectedLists.map(item => {
        item.orderGoodsList = item.orderGoodsList.filter(goods => goods.unDeliveredQuantity > 0);
        item.orderGoodsList.map(goods => {
          goods.quantity = goods.unDeliveredQuantity;
        });
        return item;
      });
      // 本地保存选择的订单信息
      localStorage.setItem('selectedAllKeys', JSON.stringify(this.selectedKeys));
      localStorage.setItem('selectedAllLists', JSON.stringify(filteredSelectedAllLists));
      this.$router.push({
        path: `/salesManagement/OrderShip/fill?timestamp=${new Date().getTime()}`,
      });
    },
    operate (type, row) {
      const path = type === 'detail' ? '/salesManagement/pickUpOrders/detail' : '/salesManagement/pickUpOrders/ship';

      this.$router.push({
        path,
        query: {
          id: row.id,
          orderCode: row.code,
          outOrderId: row.outOrderId,
          dockingSystem: row.dockingSystem,
        },
      });
    },
    async queryTenantSellerSettingDetail () {
      this.confirmPermission = false;
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      const { body } = await getTenantSellerSettingDetail({});
      const tenantSellerSetting = body || {};
      // 配置过订单确认人
      if (tenantSellerSetting.orderConfirmPersonType) {
        if (tenantSellerSetting.orderConfirmPersonType === 1
        || (tenantSellerSetting.orderConfirmPersonType === 2 && findAuthorization('gongxutong:sale:order:confirm'))
        || (tenantSellerSetting.orderConfirmPersonType === 3 && tenantSellerSetting.orderConfirmPersonUserId === userInfo?.employeeMsg?.id)) {
          this.confirmPermission = true;
        }
      } else if (findAuthorization('gongxutong:sale:order:confirm')) {
        this.confirmPermission = true;
      }
    },
  },
};
</script>
<style lang='scss' scoped>
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
}
.list-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  .content-wrapper {
    flex: 1;
    overflow: hidden;
    padding: 0 0 8px;

    .h-full {
      height: 100%;
      background-color: #fff;
      display: flex;
      flex-direction: column;

      .c_group {
        position: relative;

        .content_block {
          border-bottom: 0.5px solid #DFE2E8;
          padding: 10px;
        }

        .title {
          font-size: 14px;
          font-weight: 600;
          padding-right: 2em;
        }
      }

      .table-wrapper {
        padding: 16px 12px;
        flex: 1;
        overflow: auto;

        .ant-radio-button-wrapper {
          border-width: 0;
          background-color: #f2f4f7;

          &.active-radio {
            border-color: #e2f3fe;
            background-color: #e2f3fe;
            color: #237ffa;
          }
        }

        .ant-radio-button-wrapper:not(:first-child)::before {
          width: 0;
        }
      }
    }
  }

  .table-wrapper.fullscreen {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0px;
    z-index: 100;
    background: #FFFFFF;
  }
}

/deep/.ant-table-body::-webkit-scrollbar {
  height: 12px;
  width: 12px;
}

/deep/ .ant-table-body::-webkit-scrollbar-thumb {
  border-radius: 8px;
  box-shadow: inset 0 0 5px #c9ced6;
  background: #c9ced6;
}

//鼠标移入样式
/deep/ .ant-table-body::-webkit-scrollbar-thumb:hover {
  background: #c9ced6;
}

/deep/.ant-drawer-body {
  padding: 16px;
}
</style>
